import platform from 'platform';
import { v4 as uuidv4 } from 'uuid';
import BaseServiceCrud from './BaseServiceCrud';

export default class UserService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'my-profile';
    }

    get() {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    switchNotificationEnabled() {
        return this.fetch(`${this.domain}/${this.path}/switch-enabled`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    changePassword(request) {
        return this.fetch(`${this.domain}/${this.path}/change-password`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getProfileInfo(userAgreementMapId) {
        return this.fetch(`${this.domain}/${this.path}/profile-info?user_agreement_map_id=${userAgreementMapId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    editProfileInfo(request, userAgreementMapId) {
        return this.fetch(`${this.domain}/${this.path}/edit-profile-info?user_agreement_map_id=${userAgreementMapId}`, {
            method: 'POST',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getRecipientAndBankName() {
        return this.fetch(`${this.domain}/${this.path}/get-recipient-and-bank-name`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getUserOpt() {
        return this.fetch(`${this.domain}/${this.path}/user-opt-list`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getTrustedDevices(userAgreementMapId) {
        return this.fetch(`${this.domain}/${this.path}/trusted-devices?user_agreement_map_id=${userAgreementMapId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    editTrustedDevices(devicesIds, userAgreementMapId) {
        return this.fetch(`${this.domain}/${this.path}/edit-trusted-device?user_agreement_map_id=${userAgreementMapId}`, {
            method: 'POST',
            body: devicesIds,
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    addTrustedDevice(deviceUUID, userAgreementMapId) {
        let deviceName = platform.name;
        return this.fetch(`${this.domain}/${this.path}/add-trusted-device/${deviceUUID}/${deviceName}?user_agreement_map_id=${userAgreementMapId}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    generateDeviceUuid() {
        let generatedDeviceUuid = "";
        let currentDeviceIdFromCookie = localStorage.getItem('trustedDeviceId');
        if (currentDeviceIdFromCookie !== null && currentDeviceIdFromCookie !== undefined) {
            generatedDeviceUuid = currentDeviceIdFromCookie;
        } else {
            generatedDeviceUuid = uuidv4() + Date.now().toString(16);
        }

        return generatedDeviceUuid;
    }

    generateVerificationCodeRequest(actionType){
        return this.fetch(`${this.domain}/${this.path}/generate-verification-code/${actionType}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }


    // verifyCodeRequest(verificationCode){
    //     return this.fetch(`${this.domain}/${this.path}/verify/${verificationCode}`, {
    //         method: 'GET',
    //     }).then((res) => {
    //         return Promise.resolve(res);
    //     });
    // }

    updateApiAccessEmail(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/modify-email-api-access`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getApiAccessDetails(){
        return this.fetch(`${this.domain}/${this.path}/api-access-details`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getApiAccessPassword(){
        return this.fetch(`${this.domain}/${this.path}/api-access-password`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    apiResignation(code){
        return this.fetch(`${this.domain}/${this.path}/api-access-resignation/${code}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    verifyCodeRequestAndDisplayPassword(verificationCode){
        return this.fetch(`${this.domain}/${this.path}/api-access-password/${verificationCode}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    addApiAccess(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/generate-api-access`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

}
